import { AuthAttribute, pickRoleAttrs } from "@megaron/access-control";
import { NotificationType } from "@megaron/notifications-contracts";

export type NotificationPermission = {
  app: string;
  permissionName: string;
  targetAudienceAttributes: AuthAttribute[];
};

export const notificationPermissionMap: { [K in NotificationType]: NotificationPermission } = {
  crmInteractionMention: {
    app: "crm",
    permissionName: "Oznaczenie w interakcji w CRM",
    targetAudienceAttributes: pickRoleAttrs("crm.admin", "crm.supervisor", "crm.user"),
  },
  crmRegionAssigned: {
    app: "crm",
    permissionName: "Klient przypisany do Twojego regionu",
    targetAudienceAttributes: pickRoleAttrs("crm.admin", "crm.supervisor", "crm.user"),
  },
  crmOrderSuspended: {
    app: "crm",
    permissionName: "Zamówienie wstrzymane",
    targetAudienceAttributes: pickRoleAttrs("crm.admin", "crm.supervisor", "crm.user"),
  },
  invoiceThreadMention: {
    app: "invoices",
    permissionName: "Oznaczenie w komentarzu wątku faktury",
    targetAudienceAttributes: ["userType:megarax"],
  },
  testWebPush: {
    app: "external",
    permissionName: "Testowe powiadomienie",
    targetAudienceAttributes: ["userType:megarax"],
  },
  taxReimbursementIssued: {
    app: "external",
    permissionName: "Zwrot podatku został wydany",
    targetAudienceAttributes: ["userType:loyalty"],
  },
  productCodeRedemptionsGranted: {
    app: "loyalty",
    permissionName: "Punky za kody produktowe zostały przyznane",
    targetAudienceAttributes: ["userType:loyalty"],
  },
  referralBonusEarned: {
    app: "loyalty",
    permissionName: "Otrzymano bonus za polecenie",
    targetAudienceAttributes: ["userType:loyalty"],
  },
  affiliateCodeRedeemed: {
    app: "loyalty",
    permissionName: "Kod zaproszeniowy został wykorzystany",
    targetAudienceAttributes: ["userType:loyalty"],
  },
  test: {
    app: "external",
    permissionName: "Testowe powiadomienie",
    targetAudienceAttributes: [],
  },
  testWithoutEmailTemplate: {
    app: "external",
    permissionName: "Testowe powiadomienie bez szablonu mailowego",
    targetAudienceAttributes: [],
  },
  loyaltyAdminOrderCreated: {
    app: "loyaltyAdmin",
    permissionName: "Złożone zamówienie",
    targetAudienceAttributes: pickRoleAttrs("fulfillment.packing-user"),
  },
  affiliateCodeAssigned: {
    app: "loyalty",
    permissionName: "Kod zaproszeniowy został przyznany",
    targetAudienceAttributes: ["userType:loyalty"],
  },
  posOrderPromisedDeliveryDateSet: {
    app: "crm",
    permissionName: "Potwierdzenie zamówienia",
    targetAudienceAttributes: [],
  },
  cartInactiveForTwoWeeks: {
    app: "loyalty",
    permissionName: "Koszyk nieaktywny przez 2 tygodnie",
    targetAudienceAttributes: [],
  },
  cartAutoArchived: {
    app: "loyalty",
    permissionName: "Koszyk został automatycznie zarchiwizowany",
    targetAudienceAttributes: [],
  },
  cartRewardCancelled: {
    app: "loyalty",
    permissionName: "Nagroda w koszyku została anulowana",
    targetAudienceAttributes: [],
  },
  emailVerification: {
    app: "loyalty",
    permissionName: "Weryfikacja adresu email",
    targetAudienceAttributes: [],
  },
};
